import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { AppComponent } from './app.component';
import { RouterModule } from '@angular/router';
import {
  DxDataGridModule,
  DxSelectBoxModule,
  DxCheckBoxModule,
  DxTabPanelModule,
  DxTemplateModule,
  DxListModule,
  DxLoadPanelModule,
  DxDateBoxModule,
  DxValidatorModule,
  DxButtonModule,
  DxTooltipModule,
  DxPopupModule,
  DxMenuModule,
} from 'devextreme-angular';

import {
  DxReportViewerModule
} from 'devexpress-reporting-angular';
//import { NgxPageVisibilityModule } from 'ngx-page-visibility';
//import { ScrollDispatchModule } from '@angular/cdk/scrolling';
import { PropSearchComponentES } from './prop-search/prop-search.component';
import { DocCategoryEX2Component } from './prop-search/components/doc-category-ex2/doc-category-ex2.component';
import { DateRangePSComponent } from './prop-search/components/date-range-ps/date-range-ps.component';
//import { CityTownEXComponent } from './prop-search/components/city-town-ex/city-town-ex.component';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { CityTownExService } from './prop-search/components/city-town-ex/city-town-ex.service';
import { RecPlanNameSearchComponent } from './rec-plan-search/pages/rec-plan-name-search/rec-plan-name-search.component';
import { RecPlanBpSearchComponent } from './rec-plan-search/pages/rec-plan-bp-search/rec-plan-bp-search.component';
import { RecPlanPlannumSearchComponent } from './rec-plan-search/pages/rec-plan-plannum-search/rec-plan-plannum-search.component';
import { NameComponent } from './shared/components/name/name.component';
//import { reducers } from './store/reducers/reducers';
import { PlanroleComponent } from './rec-plan-search/components/planrole/planrole.component';
import { PlanNumComponent } from './rec-plan-search/components/plan-num/plan-num.component';
import { AddressComponent } from './shared/components/address/address.component';
//import { LibRodCoreModule } from './lib-rod-core/lib-rod-core.module';
import { NavMenuService } from './shared/services/nav-menu-service';
import { AuthenticationService } from './shared/services/authentication.service';
import { CCPaymentService } from './shared/services/cc-payment-service';
import { RecSearchService } from './rec-search/rec-search-service';
import { RecPlanNameResultPgComponent } from './rec-plan-search/pages/rec-plan-name-result-pg/rec-plan-name-result-pg.component';
import { RecPlanNameDocDispPgComponent } from './rec-plan-search/pages/rec-plan-name-doc-disp-pg/rec-plan-name-doc-disp-pg.component';
import { RecPlanBpDocDispPgComponent } from './rec-plan-search/pages/rec-plan-bp-doc-disp-pg/rec-plan-bp-doc-disp-pg.component';
import { RecPlanPlannumDocDispPgComponent } from './rec-plan-search/pages/rec-plan-plannum-doc-disp-pg/rec-plan-plannum-doc-disp-pg.component';
import { RecPlanNameSearchGridComponent } from './rec-plan-search/components/rec-plan-name-search-grid/rec-plan-name-search-grid.component';
import { RecPlanNameSearchHeaderComponent } from './rec-plan-search/components/rec-plan-name-search-header/rec-plan-name-search-header.component';
import { RecPlanDocDetailComponent } from './rec-plan-search/components/rec-plan-doc-detail/rec-plan-doc-detail.component';
import { RecPlanDocImageComponent } from './rec-plan-search/components/rec-plan-doc-image/rec-plan-doc-image.component';
//import { reducers } from 'lib-rod-core';
import { reducers } from './store/reducers/reducers';
import { RecPlanBpSearchGridComponent } from './rec-plan-search/components/rec-plan-bp-search-grid/rec-plan-bp-search-grid.component';
import { RecPlanBpSearchHeaderComponent } from './rec-plan-search/components/rec-plan-bp-search-header/rec-plan-bp-search-header.component';
import { RecPlanPlannumSearchHeaderComponent } from './rec-plan-search/components/rec-plan-plannum-search-header/rec-plan-plannum-search-header.component';
import { RecPlanPlannumSearchGridComponent } from './rec-plan-search/components/rec-plan-plannum-search-grid/rec-plan-plannum-search-grid.component';
import { RecPlanPlannumResultPgComponent } from './rec-plan-search/pages/rec-plan-plannum-result-pg/rec-plan-plannum-result-pg.component';
import { RecPlanBpResultPgComponent } from './rec-plan-search/pages/rec-plan-bp-result-pg/rec-plan-bp-result-pg.component';
import { PlanDownloadComponent } from './shared/components/plan-download/plan-download.component';

import { UnindexedDocSearchComponent } from './unindexed-search/pages/unidexed-doc-search/unindexed-doc-search.component';
import { UnindexedRecordSearchComponent } from'./unindexed-search/pages/unindexed-record-search/unindexed-record-search.component';
import { DateRangeUnindexComponent } from './unindexed-search/components/date-range-unindex/date-range-unindex.component';
import { RoleTypeComponent } from './unindexed-search/components/role-type/role-type.component';
import { UnindexedRecordDocDispPgComponent } from './unindexed-search/pages/unindexed-record-doc-disp-pg/unindexed-record-doc-disp-pg.component';
import { UnindexedDocDispPgComponent } from './unindexed-search/pages/unindexed-doc-disp-pg/unindexed-doc-disp-pg.component';


import { UnindexedRecordDocImageComponent } from './unindexed-search/components/unindexed-record-doc-image/unindexed-record-doc-image.component';
import { CompoundNameIdxComponent } from './shared/components/compound-name-idx/compound-name-idx.component';
import { LandingPageComponent } from './landing-page/landing-page.component';

import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { NavMenuItemComponent } from './nav-menu/nav-menu-item/nav-menu-item.component';
import { HeaderComponent } from './header/header.component';
import { CompoundNameComponent } from './shared/components/compound-name/compound-name.component';
import { CompoundNameComponent2 } from './shared/components/compound-name2/compound-name2.component';
//import { CompoundDoubleNameComponent } from './shared/components/compound-double-name/compound-double-name.component';
import { CityTownEXComponent } from './shared/components/city-town-ex/city-town-ex.component';
import { RoleComponent } from './shared/components/role/role.component';
import { ContainsComponent } from './shared/components/contains/contains.component';
import { SelectIndexComponent } from './shared/components/select-index/select-index.component';
import { RoleComponent2 } from './shared/components/role2/role2.component';
import { DaterangeComponent } from './shared/components/daterange/daterange.component';
import { DoccategoryexComponent } from './shared/components/doccategoryex/doccategoryex.component';
import { DoctypeexComponent } from './shared/components/doctypeex/doctypeex.component';
import { RecNameSearchGridComponent } from './rec-search/components/rec-name-search-grid/rec-name-search-grid.component';
import { RecNameSearchHeaderComponent } from './rec-search/components/rec-name-search-header/rec-name-search-header.component';
import { RecNameResultPgComponent } from './rec-search/pages/rec-name-result-pg/rec-name-result-pg.component';
import { RecImageViewer } from './rec-search/components/image-viewer/image-viewer.component';
import { RecNameSearchDetailComponent } from './rec-search/components/rec-name-search-detail/rec-name-search-detail.component';
//import { ImageViewerComponent } from 'ng2-image-viewer';
//import { ImageViewerComponent } from './shared/components/ng2-image-viewer';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { RecDocDetailParentComponent } from './rec-search/components/rec-doc-detail-parent/rec-doc-detail-parent.component';
import { RecDocDetailInfoComponent } from './rec-search/components/rec-doc-detail-info/rec-doc-detail-info.component';
//import { NavMenuService } from '../shared/services/nav-menu-service';
import { RecAddressSearchComponent } from './rec-search/pages/rec-address-search/rec-address-search.component';
import { CompoundAddressComponent } from './shared/components/compound-address/compound-address.component';
import { RecAddressResultPgComponent } from './rec-search/pages/rec-address-result-pg/rec-address-result-pg.component';
import { RecAddressSearchHeaderComponent } from './rec-search/components/rec-address-search-header/rec-address-search-header.component';
import { RecAddressSearchGridComponent } from './rec-search/components/rec-address-search-grid/rec-address-search-grid.component';
import { RecAddressDocDispPgComponent } from './rec-search/pages/rec-address-doc-disp-pg/rec-address-doc-disp-pg.component';
import { RecAlphaResultPgComponent } from './rec-search/pages/rec-alpha-result-pg/rec-alpha-result-pg.component';
import { RecAlphaSearchHeaderComponent } from './rec-search/components/rec-alpha-search-header/rec-alpha-search-header.component';
import { RecAlphaSearchGridComponent } from './rec-search/components/rec-alpha-search-grid/rec-alpha-search-grid.component';

import { RecBpSearchComponent } from './rec-search/pages/rec-bp-search/rec-bp-search.component';
import { RecBpDocDispPgComponent } from './rec-search/pages/rec-bp-doc-disp-pg/rec-bp-doc-disp-pg.component';
import { BookPageComponent } from './shared/components/book-page/book-page.component';
import { RecdocComponent } from './shared/components/recdoc/recdoc.component';
import { RecDocSearchComponent } from './rec-search/pages/rec-doc-search/rec-doc-search.component';
import { RecDocnumDocDispPgComponent } from './rec-search/pages/rec-docnum-doc-disp-pg/rec-docnum-doc-disp-pg.component';
import { DocBasketComponent } from './shared/components/doc-basket/doc-basket.component';
import { DocBasketAddComponent } from './shared/components/doc-basket-add/doc-basket-add.component';
import { DocBasketExComponent } from './shared/components/doc-basket-ex/doc-basket-ex.component';
import { RecNameDocDispPgComponent } from './rec-search/pages/rec-name-doc-disp-pg/rec-name-doc-disp-pg.component';
import { RecNameSearchComponent } from './rec-search/pages/rec-name-search/rec-name-search.component';
import { RecDateSearchComponent } from './rec-search/pages/rec-date-search/rec-date-search.component';
import { RecDateResultPgComponent } from './rec-search/pages/rec-date-result-pg/rec-date-result-pg.component';
import { RecDateSearchHeaderComponent } from './rec-search/components/rec-date-search-header/rec-date-search-header.component';
import { RecDateSearchGridComponent } from './rec-search/components/rec-date-search-grid/rec-date-search-grid.component';
import { RecDateDocDispPgComponent } from './rec-search/pages/rec-date-doc-disp-pg/rec-date-doc-disp-pg.component';
import { RecValueSearchComponent } from './rec-search/pages/rec-value-search/rec-value-search.component';
import { RecValueResultPgComponent } from './rec-search/pages/rec-value-result-pg/rec-value-result-pg.component';
import { RecValueDocDispPgComponent } from './rec-search/pages/rec-value-doc-disp-pg/rec-value-doc-disp-pg.component';
import { AmountrangeComponent } from './shared/components/amountrange/amountrange.component';
import { DocCategoryVsComponent } from './shared/components/doc-category-vs/doc-category-vs.component';
import { CompundNameOwnerComponent } from './shared/components/compund-name-owner/compund-name-owner.component';
import { CertificateNoComponent } from './shared/components/certificate-no/certificate-no.component';
import { PropertySearchPgComponent } from './prop-search/pages/property-search-pg/property-search-pg.component';
import { PropertySearchResultPgComponent } from './prop-search/pages/property-search-result-pg/property-search-result-pg.component';
import { PropertySearchDocDispPgComponent } from './prop-search/pages/property-search-doc-disp-pg/property-search-doc-disp-pg.component';
import { PropertySearchHeaderComponent } from './prop-search/components/property-search-header/property-search-header.component';
import { PropertySearchDocDetailComponent } from './prop-search/components/property-search-doc-detail/property-search-doc-detail.component';
import { PropertySearchDocImageComponent } from './prop-search/components/property-search-doc-image/property-search-doc-image.component';
import { PropertySearchGridComponent } from './prop-search/components/property-search-grid/property-search-grid.component';
//import { LibRodCoreComponent } from './lib-rod-core.component';
import { ReportViewerComponent } from './shared/components/report-viewer/report-viewer.component';
import { ReportViewerPlanComponent } from './shared/components/report-viewer-plan/report-viewer-plan.component';
import { RecValueSearchHeaderComponent } from './rec-search/components/rec-value-search-header/rec-value-search-header.component';
import { RecValueSearchGridComponent } from './rec-search/components/rec-value-search-grid/rec-value-search-grid.component';
import { DateRangeParentComponent } from './shared/components/date-range-parent/date-range-parent.component';
import { DatePickerComponent } from './shared/components/date-picker/date-picker.component';
import { basketVM } from './shared/viewmodels/basketVM';
import { MatLegacyProgressSpinner as MatProgressSpinner, MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyMenu as MatMenu, MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { ShoppingBasketService } from './shared/services/shopping-basket.service';

@NgModule({
  declarations: [
    AppComponent,
    PropSearchComponentES,
    DocCategoryEX2Component,
    DateRangePSComponent,
    AddressComponent,
    CityTownEXComponent,
    RecPlanNameSearchComponent,
    RecPlanBpSearchComponent,
    RecPlanPlannumSearchComponent,
    NameComponent,
    PlanroleComponent,
    PlanNumComponent,
    RecPlanNameResultPgComponent,
    RecPlanNameDocDispPgComponent,
    RecPlanBpDocDispPgComponent,
    RecPlanPlannumDocDispPgComponent,
    RecPlanNameSearchGridComponent,
    RecPlanNameSearchHeaderComponent,
    RecPlanDocDetailComponent,
    RecPlanDocImageComponent,
    RecPlanBpSearchGridComponent,
    RecPlanBpSearchHeaderComponent,
    RecPlanPlannumSearchHeaderComponent,
    RecPlanPlannumSearchGridComponent,
    RecPlanPlannumResultPgComponent,
    RecPlanBpResultPgComponent,
    PlanDownloadComponent,
    UnindexedDocSearchComponent,
    UnindexedRecordSearchComponent,
    DateRangeUnindexComponent,
    RoleTypeComponent,
    UnindexedDocDispPgComponent,
    UnindexedRecordDocDispPgComponent,
    UnindexedRecordDocImageComponent,
    CompoundNameIdxComponent,
    LandingPageComponent,
    //ImageViewerComponent,
    NavMenuComponent,
    NavMenuItemComponent,
    HeaderComponent,
    CompoundNameComponent,
    CompoundNameComponent2,
    //CompoundDoubleNameComponent,
    AddressComponent,
    CityTownEXComponent,
    RoleComponent,
    ContainsComponent,
    SelectIndexComponent,
    RoleComponent2,
    DaterangeComponent,
    DoccategoryexComponent,
    DoctypeexComponent,
    RecNameSearchGridComponent,
    RecNameSearchDetailComponent,
    RecNameSearchHeaderComponent,
    RecNameResultPgComponent,
    RecImageViewer,
    RecDocDetailParentComponent,
    RecDocDetailInfoComponent,
    RecAddressSearchComponent,
    CompoundAddressComponent,
    RecAddressResultPgComponent,
    RecAddressSearchHeaderComponent,
    RecAddressSearchGridComponent,
    RecAddressDocDispPgComponent,
    RecAlphaResultPgComponent,
    RecAlphaSearchHeaderComponent,
    RecAlphaSearchGridComponent,
    RecBpSearchComponent,
    RecBpDocDispPgComponent,
    BookPageComponent,
    RecdocComponent,
    RecDocSearchComponent,
    RecDocnumDocDispPgComponent,
    DocBasketComponent,
    DocBasketAddComponent,
    DocBasketExComponent,
    RecNameDocDispPgComponent,
    RecNameSearchComponent,
    RecDateSearchComponent,
    RecDateResultPgComponent,
    RecDateSearchHeaderComponent,
    RecDateSearchGridComponent,
    RecDateDocDispPgComponent,
    RecValueSearchComponent,
    RecValueResultPgComponent,
    RecValueDocDispPgComponent,
    RecValueSearchHeaderComponent,
    AmountrangeComponent,
    DocCategoryVsComponent,
    CompundNameOwnerComponent,
    CertificateNoComponent,
    PropertySearchPgComponent,
    PropertySearchDocDispPgComponent,
    PropertySearchHeaderComponent,
    PropertySearchDocDetailComponent,
    PropertySearchDocImageComponent,
    PropertySearchResultPgComponent,
    PropertySearchGridComponent,
    ReportViewerComponent,
    ReportViewerPlanComponent,
    RecValueSearchGridComponent,
    DateRangeParentComponent,
    DatePickerComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    StoreModule.forFeature('coresearchdata', reducers),
    CommonModule,
    FormsModule,
    DxDataGridModule,
    DxSelectBoxModule,
    DxCheckBoxModule,
    DxTabPanelModule,
    DxTemplateModule,
    DxListModule,
    DxLoadPanelModule,
    DxDateBoxModule,
    DxValidatorModule,
    DxButtonModule,
    DxTooltipModule,
    DxPopupModule,
    DxMenuModule,
    DxReportViewerModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatIconModule,
    NgxExtendedPdfViewerModule,
    /*NgxPageVisibilityModule,*/
    /* ImageViewerModule,*/
    StoreModule.forRoot({
    
    }),
    //StoreModule.forFeature('coresearchdata', reducers),
    //StoreModule.forFeature('regsearchdata', regreducers),

    //LibRodCoreModule,
    //StoreModule.forFeature('coresearchdata', reducers),
//StoreModule.forFeature('regsearchdata', regreducers),
//LibRodCoreModule,
RouterModule.forRoot([
    { path: '', component: LandingPageComponent, pathMatch: 'full' },
    { path: 'intmap/:machineId', component: LandingPageComponent },
    { path: 'propsearch', redirectTo: '/rodcore', pathMatch: 'full' },
    { path: 'espropsearch', component: PropSearchComponentES },
    { path: 'rec-plan-name-search', component: RecPlanNameSearchComponent },
    { path: 'rec-plan-name-result-pg', component: RecPlanNameResultPgComponent },
    { path: 'rec-plan-name-doc-disp-pg/:book/:page/:bookType', component: RecPlanNameDocDispPgComponent },
    { path: 'rec-plan-plannum-search', component: RecPlanPlannumSearchComponent },
    { path: 'rec-plan-plannum-result-pg', component: RecPlanPlannumResultPgComponent },
    { path: 'rec-plan-plannum-doc-disp-pg/:book/:page/:bookType', component: RecPlanPlannumDocDispPgComponent },
    { path: 'rec-plan-bp-search', component: RecPlanBpSearchComponent },
    { path: 'rec-plan-bp-result-pg', component: RecPlanBpResultPgComponent },
    { path: 'rec-plan-bp-doc-disp-pg/:book/:page/:bookType', component: RecPlanBpDocDispPgComponent },
    { path: 'unindexed-doc-search', component: UnindexedDocSearchComponent },
    { path: 'unindexed-record-search1/:majorgroup', component: UnindexedRecordSearchComponent },
    { path: 'unindexed-record-search2/:majorgroup', component: UnindexedRecordSearchComponent },
    { path: 'unindexed-record-search3/:majorgroup', component: UnindexedRecordSearchComponent },
    { path: 'unindexed-record-search4/:majorgroup', component: UnindexedRecordSearchComponent },
    { path: 'unindexed-record-search5/:majorgroup', component: UnindexedRecordSearchComponent },
    //{ path: 'unindexed-record-doc-disp-pg/:indexbook/:indexgroup/:indexpage/:dategroup', component: UnindexedRecordDocDispPgComponent },
    //{ path: 'unindexed-record-doc-disp-pg/:Book/:Page/:indexId', component: UnindexedRecordDocDispPgComponent },
    { path: 'unindexed-record-doc-disp-pg/:Book/:Page/', component: UnindexedRecordDocDispPgComponent },
    { path: 'unindexed-doc-disp-pg/:Book/:Page/:indexId', component: UnindexedDocDispPgComponent },
    { path: 'rodcore', component: PropertySearchPgComponent, pathMatch: 'full', data: { title: 'South Essex' } },
    { path: 'property-search-result-pg', component: PropertySearchResultPgComponent },
    { path: 'property-search-doc-disp-pg/:docId/:book/:page', component: PropertySearchDocDispPgComponent },
    { path: 'property-search-doc-disp-pg/:docId/:docNum', component: PropertySearchDocDispPgComponent },
    { path: 'rec-name-result-pg', component: RecNameResultPgComponent },
    { path: 'rec-name-result-pg/:lname/:fname/:role', component: RecNameResultPgComponent },
    { path: 'rec-image-viewer/:docId/:book/:page', component: RecImageViewer },
    { path: 'rec-doc-detail-parent/:docId/:book/:page', component: RecDocDetailParentComponent },
    { path: 'rec-address-search', component: RecAddressSearchComponent },
    { path: 'rec-address-result-pg', component: RecAddressResultPgComponent },
    { path: 'rec-address-doc-disp-pg/:docId/:book/:page', component: RecAddressDocDispPgComponent },
    { path: 'rec-address-doc-disp-pg/:docId/:book/:page/:index_page', component: RecAddressDocDispPgComponent },
    { path: 'rec-alpha-result-pg', component: RecAlphaResultPgComponent },
    { path: 'rec-bp-search', component: RecBpSearchComponent },
    { path: 'rec-bp-doc-disp-pg/:book/:page', component: RecBpDocDispPgComponent },
    { path: 'rec-bp-doc-disp-pg/:book/:page/:source', component: RecBpDocDispPgComponent },
    { path: 'rec-doc-search', component: RecDocSearchComponent },
    { path: 'rec-docnum-doc-disp-pg/:docId', component: RecDocnumDocDispPgComponent },
    { path: 'rec-name-doc-disp-pg/:docId/:book/:page', component: RecNameDocDispPgComponent },
    { path: 'rec-name-search', component: RecNameSearchComponent },
    { path: 'rec-date-search', component: RecDateSearchComponent },
    { path: 'rec-date-result-pg', component: RecDateResultPgComponent },
    { path: 'rec-value-search', component: RecValueSearchComponent },
    { path: 'rec-value-result-pg', component: RecValueResultPgComponent },
    { path: 'report-viewer/:repName', component: ReportViewerComponent },
    { path: 'report-viewer-plan/:repName', component: ReportViewerPlanComponent }
], {})
  ],
  providers: [
    NavMenuService,
    RecSearchService,
    CityTownExService,
    AuthenticationService,
    ShoppingBasketService,
    CCPaymentService
  ],
  exports: [
      CommonModule,
      CompoundNameComponent,
      CompoundNameComponent2,
    CityTownEXComponent,
    DaterangeComponent,
    BookPageComponent,
    DateRangeParentComponent,
    DatePickerComponent,
    /*ImageViewerComponent,*/
/*    ImageViewerModule,*/
    DxPopupModule,
      DocBasketComponent,
      DocBasketAddComponent,
    DocBasketExComponent
    
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
